module.exports = __webpack_public_path__ + "static/img/1_3.7ba547e1.jpg";